import './audit-campaign-search-menu.scss'

import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { AddItemModal } from '@skinsoft/ui';
import { OPEN_ADD_ITEM_MODAL } from '../../../../busTopics';

export const AuditCampaignSearchMenu = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAddItemModal: AddItemModal
    },
    props: [''],
    template: require('./audit-campaign-search-menu.html'),
    methods: {
        openModal() {
            this.emitOnBus(OPEN_ADD_ITEM_MODAL)
        },
    },
})
